import { createAsyncReducer } from '../../standard-actions/reducers';
import {
    IPostTicketCommentAction,
    IPostTicketCommentSuccessAction,
    IPostTicketCommentErrorAction
} from '../actions/ticket-details/post-ticket-comment';
import { ITicketsState } from '../state';
import { initialState } from './initial-state';

export type PostTicketCommentAction
    = IPostTicketCommentAction
    | IPostTicketCommentSuccessAction
    | IPostTicketCommentErrorAction;

const init = (state: ITicketsState, action: PostTicketCommentAction) => ({
    ...state,
    ticketComment: {
        ...initialState.ticketComment,
        status: action.status
    }
});

const success = (state: ITicketsState, action: PostTicketCommentAction) => {
    return {
        ...state,
        ticketComment: {
            ...initialState.ticketComment,
            status: action.status
        }
    };
};

const failure = (state: ITicketsState, action: PostTicketCommentAction) => ({
    ...state,
    ticketComment: {
        ...initialState.ticketComment,
        status: action.status,
        error: (action as IPostTicketCommentErrorAction).error
    }
});

export const postTicketCommentReducer = createAsyncReducer(initialState, init, success, failure);
